module.exports = __webpack_public_path__ + "img/cangzhou-9e87de.png";